import { render } from "./MouvementDuStock.vue?vue&type=template&id=48b9fb75&ts=true"
import script from "./MouvementDuStock.vue?vue&type=script&lang=ts"
export * from "./MouvementDuStock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__